import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Paper,
  Box,
} from "@mui/material";

const CryptoTrackers = () => {
  const [coinNames, setCoinNames] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const res = await fetch(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false"
        );
        if (!res.ok) throw new Error("Failed to fetch data");
        const data = await res.json();
        setCoinNames(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "89vh",
        }}
      >
        Loading💰...
      </Box>
    );
  }

  if (error) {
    return (
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "89vh",
          color: "red",
        }}
      >
        Error: {error}
      </Typography>
    );
  }

  const filterCoins = coinNames.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase().trim())
  );

  return (
    <Box sx={{px:{xs:3,md:4},py:3}}>
      <Grid container spacing={2} justifyContent='center'>

        <Grid item xs={12} textAlign='center'>
          <Typography variant="h5" sx={{fontWeight:'bold'}}> 
            Crypto Tracker 💰
          </Typography>
        </Grid>

        <Grid item xs={12} sm={8} md={6} lg={4}>
          <TextField
            label="Search for a crypotocurrency"
            fullWidth
            value={search}
            onChange={(e)=>setSearch(e.target.value)}
          />
        </Grid>

        <Grid container spacing={3} justifyContent='center' m={1}>
          {filterCoins.length === 0 ? (
            <Typography variant="h6" color="gray">
              No results found 😕
            </Typography>
          ):(
            filterCoins.map((c)=>(
              <Grid key={c.id} item xs={12} sm={6} md={4} lg={3}>
                <Paper
                  elevation={3}
                  sx={{
                    p:2,
                    borderRadius:2,
                    textAlign:'center',
                    transition:'0.3s',
                    backgroundColor:'#1E1E1E',
                    color:'#FFF',
                    "&:hover":{transform: 'scale(1.05)',boxShadow:5}
                  }}
                >
                  <img 
                    src={c.image}
                    alt={c.name}
                    width={60}
                    height={60}
                    style={{marginBottom:'10px'}}
                  />
                  <Typography variant="h6" color="#FFD700">{c.name}</Typography>
                  <Typography variant="body1" color="#B0BEC5" mt={2}>{c.symbol.toUpperCase()}</Typography>
                  <Typography variant="h6" fontWeight='bold' color="#4CAF50" mt={2}>
                    Current Price : ${c.current_price.toFixed(2)}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#90CAF9" }} mt={2}>
                    24h High : ${c.high_24h} | 24h Low : ${c.low_24h}
                  </Typography>
                  <Typography variant="h6" sx={{color: c.price_change_percentage_24h >0 ? "#4CAF50" : "#F44336"}} mt={2}>
                    24h Change : {c.price_change_percentage_24h.toFixed(2)}%
                  </Typography>
                  <Typography variant="body2" color="#B0BEC5" mt={2}>
                    Market Cap : ${c.market_cap_change_24h.toString()}
                  </Typography>
                  <Typography variant="body2" color="#FFD700" mt={2}>
                    ATH : ${c.ath} ({c.ath_change_percentage.toFixed(2)}%)
                  </Typography>
                  <Typography variant="body2" color="#FF8A65" mt={2}>
                    ATL : ${c.atl} ({c.atl_change_percentage.toFixed(2)}%)
                  </Typography>
                </Paper>
              </Grid>
            ))
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CryptoTrackers;

